import { OriNumberInput } from '@/src/components/Antd';
import { isNumber } from 'lodash';
import React from 'react';
import {
  Item as ItemWrapper,
  Row,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import {
  bottomPadding,
  moduleStyle,
  topPadding,
} from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
const TopAndBottomPadding = (props) => {
  const { disabled } = props;
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <Section {...sectionProps}>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper title={getI18n('general.topPadding')}>
                <Field name={[moduleStyle, topPadding]}>
                  {(props, meta) => {
                    const { value, onChange } = props;
                    return (
                      <OriNumberInput
                        value={value}
                        onChange={(n) => {
                          if (isNumber(n)) {
                            onChange(n);
                          } else {
                            onChange(0);
                          }
                        }}
                        disabled={disabled}
                        size='large'
                        suffix={'px'}
                      />
                    );
                  }}
                </Field>
              </ItemWrapper>
            ),
          },
          {
            child: (
              <ItemWrapper title={getI18n('general.bottomPadding')}>
                <Field name={[moduleStyle, bottomPadding]}>
                  {(props, meta) => {
                    const { value, onChange } = props;
                    return (
                      <OriNumberInput
                        value={value}
                        onChange={(n) => {
                          if (isNumber(n)) {
                            onChange(n);
                          } else {
                            onChange(0);
                          }
                        }}
                        disabled={disabled}
                        size='large'
                        suffix={'px'}
                      />
                    );
                  }}
                </Field>
              </ItemWrapper>
            ),
          },
        ]}
      />
    </Section>
  );
};
export default TopAndBottomPadding;
